import {
  VOUCHER_DUPLICATE_START,
  VOUCHER_DUPLICATE_SUCCESS,
  VOUCHER_DUPLICATE_ERROR,
  CLEAR_DUPLICATE_VOUCHER,
} from "../types/duplicateVoucherType";

const initialState = {
  loading: false,
  error: null,
  duplicateVoucher: null,
};


export default function duplicateVoucherReducer(state = initialState, action) {
  switch (action.type) {
    case VOUCHER_DUPLICATE_START:
      return { ...state, loading: true, error: null };
    case VOUCHER_DUPLICATE_SUCCESS:
      return { ...state, loading: false, duplicateVoucher: action.payload };
    case VOUCHER_DUPLICATE_ERROR:
      return { ...state, loading: false, error: action.payload };
    case CLEAR_DUPLICATE_VOUCHER:
      return { ...state, duplicateVoucher: null, error: null };
    default:
      return state;
  }
};